import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ICategory } from "../categorySlice";

export const getAllCategory = createAsyncThunk(
  "Category/FindAllCategory",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Category/FindAllCategory`,
        {
          Category: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Category:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createCategory = createAsyncThunk(
  "Category/InsertCategory",
  async (CategoryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Category/InsertCategory`,
        CategoryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Category:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateCategory = createAsyncThunk(
  "Category/UpdateCategory",
  async (CategoryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Category/UpdateCategory`,
        CategoryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Category :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteCategory = createAsyncThunk(
  "Category/DeleteCategory",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Category/DeleteCategory`,
        {
          ID,
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Category :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getCategoryByID = createAsyncThunk(
  "Category/FindByIDCategory",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Category/FindByIDCategory`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Name: result.Name,
        CategoryURL: result.CategoryURL,
        Image: result.Image,
        IsActive: result.IsActive ? 1 : 2,
      } as ICategory;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Category :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveCategory = createAsyncThunk(
  "Category/FindAllActiveCategory",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Category/FindAllActiveCategory`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Categoryes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveCategory = createAsyncThunk(
  "Category/ActiveInActiveCategory",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Category/ActiveInActiveCategory`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Category :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateCategoryImage = createAsyncThunk(
  "Category/CategoryImageUpdate",
  async (ClientLogoData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Category/CategoryImageUpdate`,
        ClientLogoData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating client logo:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
